
import moment from 'moment'
import MenuIcon from '@mui/icons-material/Menu'
import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'

import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import config from 'config'

import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import { AppCtx } from '$src/App'

/**
 * Docs Search
**/
const DocsSearch = (props) => {

  const apiRouter = useApiRouter()

  // const {
  // } = useContext(AppCtx)

  const [ q, setQ ] = useState('')
  const [ doc, setDoc ] = useState({})
  const [ docModalOpen, setDocModalOpen ] = useState(false)

  const handleSubmit = (ev) => {
    ev.preventDefault()

    fetch(apiRouter.docsSearchPath(q)).then(r => {
      if (200 == r.status) {
        return r.json()
      } else {
        throw r.status
      }
    }).then(r => {
      logg(r, 'r')

      setDocModalOpen(true)
      setDoc(r)
    }).catch(err => {
      toast('No line item found matching your criteria.')
    })
  }

  return <div  >
    <Modal
      ariaHideApp={false}
      className="DefinitionModal BaseModal"
      isOpen={docModalOpen}
      onRequestClose={ () => setDocModalOpen(false) }
      overlayClassName="DefinitionModalOverlay"
    >
      <div className='modal-header'>
        <h5>{ doc.ubpr_code }</h5>
        <div className='close' onClick={() => setDocModalOpen(false)}>&times;</div>
      </div>
      <div className='modal-content' >
        { doc.definition }
      </div>
    </Modal>


    <form onSubmit={handleSubmit} className="DocsSearch" >
      <label>Search by Line Item Code</label>
      <input type='text' value={q} onChange={(ev) => setQ(ev.target.value) } />
      <input type='submit' value='Search' />
    </form>
  </div>
}
export default DocsSearch
